import { useEnv } from './EnvContext';
import { useAppEnv } from '../api/useAppEnv';

/**
 * Editability for the GLOBAL / admin-catalog pages (tasks, cohorts,
 * sweepstakes, ToS, questionnaires, collections, plan-cohort-purse, the
 * reference catalogs).
 *
 * POLICY (globals-everywhere, decoupled from the per-tenant flag): global
 * catalogs are editable on EVERY NON-PROD env — last-writer-wins, the
 * canonical promote-source stays dev01, and prod remains read-only (the path
 * to prod is promote). The gate follows the env the UI is POINTED AT: writes
 * route browser-direct to the selected env, whose server fence (writeFence
 * GLOBALS_AUTHORING_PREFIXES, non-prod only) is the authoritative gate.
 *
 * DELIBERATELY independent of appEnv.perTenantEditingEnvEnabled — that flag
 * switches the per-tenant authoring-home model, which stays as-is. It is also
 * NOT ANDed with appEnv.globalsEditableHere (a POD-level bit, false on the
 * prod portal) — that combination locked the entire admin view read-only on
 * the prod portal even while browsing uat/qa.
 *
 * Fail-closed while /api/app-env loads (no flash of editable UI).
 */
export function useGlobalsEditable(): boolean {
  const { currentEnv } = useEnv();
  const appEnv = useAppEnv();

  if (!appEnv) return false; // fail-closed during /api/app-env load
  return currentEnv !== 'prod';
}

export default useGlobalsEditable;
